import { useState, useEffect } from "react";
import "./styles/pay.scss";
// import CreditCard from "./component/creditcard.js";
import axios from "axios";
import { backend } from "../../components/apipath";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { usePayment } from "../../components/PaymentContext";

function Pay() {
  const { step } = usePayment();
  const [errors, setErrors] = useState({});
  const [coupon, setCoupon] = useState("");
  const [couponInfo, setCouponInfo] = useState(null);
  const [planData, setPlanData] = useState(null);
  const [formData, setFormData] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState("ATM");
  // const [ccInputs, setCcInputs] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [ccEnabled, setCcEnabled] = useState(false);
  const [ccQuota, setCcQuota] = useState(null);
  //擋信用卡
  const FORCE_DISABLE_CC = true;
  // 這個冪等鍵本頁面只產一次，帶到後端做去重
  const [idemKey] = useState(
    () =>
      (window.crypto?.randomUUID?.() ??
        `ord_${Date.now()}_${Math.random().toString(36).slice(2)}`)
  );

  const navigate = useNavigate();

  // RP 加購項目價目表（id -> 金額）
  const RP_ADDON_PRICE_MAP = {
    ua_extend_18000: 18000,
    final_review_8000: 8000,
    chinese_course_1500: 1500,
    consult_1500: 1500,
    textbook_2500: 2500,
  };
  const BOOK_PRICE_MAP = {
    1: 2500,
    2: 2500,
    3: 2500,
    4: 2500,
    5: 2500,
    6: 2500,
    22: 2500,
    23: 2500,
    24: 2500,
    25: 2500,
    26: 2500,
    27: 3000,
  };

  const calcBooksTotal = (books = []) => {
    if (!Array.isArray(books)) return 0;

    return books.reduce((sum, id) => {
      return sum + Number(BOOK_PRICE_MAP[String(id)] || 0);
    }, 0);
  };
  // Step gate
  useEffect(() => {
    const savedStep = parseInt(localStorage.getItem("paymentStep")) || 0;
    if (step < 3 && savedStep < 3) {
      navigate("/registration/payinfo");
    }
  }, [step, navigate]);

  // 載入方案 & 前一頁表單
  useEffect(() => {
    (async () => {
      try {
        const selectedPlan = localStorage.getItem("selectedPlan"); // 產品 id
        const res = await axios.get(`${backend}product/${selectedPlan}`);
        setPlanData(res.data.data[0]);
      } catch (err) {
        console.error("Error fetching plan details:", err);
      }
      const stored = JSON.parse(localStorage.getItem("formData") || "{}");
      setFormData(stored);
    })();
  }, []);


  useEffect(() => {
    const checkCreditCardQuota = async () => {
      if (!planData?.product_id) return;

      const productId = Number(planData.product_id);

      // 只有 product_id 1,2 才可能顯示信用卡
      if (![1, 2].includes(productId)) {
        setCcEnabled(false);
        setCcQuota(null);

        if (paymentMethod === "CreditCard") {
          setPaymentMethod("ATM");
        }

        return;
      }

      try {
        const res = await axios.get(`${backend}pay/hncb/quota`, {
          params: { product_id: productId },
          withCredentials: true,
        });

        setCcQuota(res.data);
        //擋信用卡
        // setCcEnabled(!!res.data.enabled);
        setCcEnabled(
          FORCE_DISABLE_CC
            ? false
            : !!res.data.enabled
        );

        if (!res.data.enabled && paymentMethod === "CreditCard") {
          setPaymentMethod("ATM");
        }
      } catch (err) {
        console.error("查詢信用卡名額失敗", err);
        setCcEnabled(false);
        setCcQuota(null);

        if (paymentMethod === "CreditCard") {
          setPaymentMethod("ATM");
        }
      }
    };

    checkCreditCardQuota();
  }, [planData?.product_id]);
  const handlePaymentMethodChange = (method) => setPaymentMethod(method);

  // 優惠碼
const checkCoupon = async () => {
  if (isSubmitting) return;

  // 取得目前選擇的方案 product_id
  const product_id = Number(localStorage.getItem("selectedPlan"));

  // ✅ 取得會員 mem_id
  const authData = JSON.parse(localStorage.getItem("auth") || "{}");
  const mem_id = Number(authData.mem_id);

  if (!product_id) {
    Swal.fire({
      icon: "warning",
      title: "尚未選擇方案",
      text: "請先選擇方案後再輸入優惠碼。",
    });
    return;
  }

  if (!mem_id) {
    Swal.fire({
      icon: "warning",
      title: "尚未登入",
      text: "請先登入會員後再使用優惠碼。",
    });
    return;
  }

  try {
    const res = await fetch(`${backend}order/checkCoupon`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        code: coupon,
        product_id,
        mem_id,
      }),
    });

    const data = await res.json();

    if (data.success) {
      setCouponInfo(data);

      Swal.fire({
        icon: "success",
        title: "優惠碼可使用"
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "優惠碼錯誤",
        text: data.message || "查無此優惠碼，請重新確認！",
      });
    }
  } catch (e) {
    console.error(e);
    Swal.fire({
      icon: "error",
      title: "連線失敗",
      text: "無法驗證優惠碼，請稍後再試。",
    });
  }
};

  // 折扣邏輯：只折「方案＋書本」，不折運費
  const calculateDiscountedPrice = (price) => {
    if (!couponInfo) return price;
    const discount = parseFloat(couponInfo.data.discount || 0);
    return Math.max(0, Number(price) - discount);
  };

  // ======= 計算顯示金額（關鍵邏輯）=======
  const isCSU = String(planData?.product_id ?? "") === "10";
  const parentId = String(planData?.parent_id ?? "");
  const isCPA = parentId === "1";
  const isCMA = parentId === "2";
  const isEA = parentId === "3";
  const isUT = parentId === "6";
  const isRP = parentId === "7";
  const isTEPB = parentId === "9";
  const hasBookOption = isEA || isCPA || isCMA;

  const unitPrice = Number(planData?.price || 0);
  const csuCount = isCSU
    ? (Array.isArray(formData?.bridge_courses) ? formData.bridge_courses.length : 0)
    : 1;

  //CIA計算
  const isCIASingle = String(planData?.product_id ?? "") === "28";

  const ciaCount = isCIASingle
    ? (Array.isArray(formData?.cia_subjects) ? formData.cia_subjects.length : 1)
    : 1;

  // 方案本體
  const planSubtotal = unitPrice * (isCSU ? csuCount : ciaCount);

  // RP 加購總額
  const rpAddons = Array.isArray(formData?.cpa_addons) ? formData.cpa_addons : [];
  const rpAddonTotal = isRP
    ? rpAddons.reduce((sum, id) => sum + (RP_ADDON_PRICE_MAP[String(id)] || 0), 0)
    : 0;

  // 書本（CPA/EA/CMA 都計）
  const bookCount = hasBookOption && Array.isArray(formData?.book) ? formData.book.length : 0;
  const booksTotal = calcBooksTotal(formData?.book);

  const needsCourier =
  hasBookOption && Array.isArray(formData?.deliver) && formData.deliver.includes("快遞");

  const addressType = String(formData?.address_type || "TW").toUpperCase();

  const booksPerBox = isEA ? 3 : 2;

  const shippingFee =
    hasBookOption && needsCourier && bookCount > 0
      ? (
          addressType === "FOREIGN"
            ? 1200
            : Math.ceil(bookCount / booksPerBox) * 100
        )
      : 0;

  // 折扣後方案金額
  const discountedPlanOnly = calculateDiscountedPrice(planSubtotal);

  // 未折扣小計
  const baseSubtotal =
    planSubtotal +
    booksTotal +
    shippingFee +
    rpAddonTotal;

  // 折扣後總額
  const discountedTotal =
    discountedPlanOnly +
    booksTotal +
    shippingFee +
    rpAddonTotal;


  // ✅ 有買書 + 不是快遞寄送 + 台灣地址 => 詢問是否前往領書申請
  const shouldAskBookPickup = (form_data, planData) => {
    const parentId = String(planData?.parent_id ?? "");

    const hasBookOption =
      parentId === "1" || // CPA
      parentId === "2" || // CMA
      parentId === "3";   // EA

    const bookCount =
      hasBookOption && Array.isArray(form_data?.book)
        ? form_data.book.length
        : 0;

    const addressType = String(
      form_data?.address_type || "TW"
    ).toUpperCase();

    const needsCourier =
      hasBookOption &&
      Array.isArray(form_data?.deliver) &&
      form_data.deliver.includes("快遞");

    return (
      bookCount > 0 &&
      !needsCourier &&
      addressType === "TW"
    );
  };
  
  

  // 送單
  const handleSubmit = async () => {
    if (isSubmitting) return; // 二次點擊直接忽略
    setIsSubmitting(true);

    let navigated = false; // ✅ 避免 finally 解鎖造成 UI 閃一下

    try {
      const form_data = JSON.parse(localStorage.getItem("formData") || "{}");
      const mem_data = JSON.parse(localStorage.getItem("auth") || "{}");
      const transfer_date = document.getElementById("payment")?.value || "";
      const transfer_name = document.getElementById("payer")?.value || "";
      const order_date = new Date().toISOString().split("T")[0];

      let formValid = true;
      const newErrors = {};

      if (paymentMethod === "ATM") {

        if (!transfer_date) {
          newErrors.transfer_date = "請填寫匯款 / 轉帳日期";
          formValid = false;
        }

        if (!transfer_name.trim()) {
          newErrors.transfer_name = "請填寫匯款人姓名或帳號末五碼";
          formValid = false;
        }

      }
      setErrors(newErrors);
      if (!formValid) return;

      // 依產品 exp 月數算 software_ex
      const expMonths = planData?.exp ? parseInt(planData.exp, 10) : 12;
      const software_ex = new Date();
      if (!isNaN(expMonths)) {
        software_ex.setMonth(software_ex.getMonth() + expMonths);
      }

      // 重新計算（以最新 form_data 為準）
      const _isCSU = String(planData?.product_id ?? "") === "10";
      const _parentId = String(planData?.parent_id ?? "");
      const _isCPA = _parentId === "1";
      const _isCMA = _parentId === "2";
      const _isEA = _parentId === "3";
      const _isUT = _parentId === "6";
      const _isRP = _parentId === "7";
      const _isTEPB = _parentId === "9";
      const _hasBookOption = _isEA || _isCPA || _isCMA;

      const _rpAddons = Array.isArray(form_data?.cpa_addons) ? form_data.cpa_addons : [];
      const _rpAddonTotal = _isRP
        ? _rpAddons.reduce((sum, id) => sum + (RP_ADDON_PRICE_MAP[String(id)] || 0), 0)
        : 0;

      const _unitPrice = Number(planData?.price || 0);
      const _csuCount = _isCSU
        ? (Array.isArray(form_data.bridge_courses) ? form_data.bridge_courses.length : 0)
        : 1;

      const _isCIASingle = String(planData?.product_id ?? "") === "28";

      const _ciaCount = _isCIASingle
        ? (Array.isArray(form_data.cia_subjects) ? form_data.cia_subjects.length : 1)
        : 1;

      const _planSubtotal = _unitPrice * (_isCSU ? _csuCount : _ciaCount);

      const _bookCount =
        _hasBookOption && Array.isArray(form_data.book) ? form_data.book.length : 0;
      const _booksTotal = calcBooksTotal(form_data.book);

      const _needsCourier =
        _hasBookOption && Array.isArray(form_data?.deliver) && form_data.deliver.includes("快遞");

      const _addressType = String(form_data.address_type || "TW").toUpperCase();

      const _booksPerBox = _isEA ? 3 : 2;

      const _shippingFee =
        _hasBookOption && _needsCourier && _bookCount > 0
          ? (
              _addressType === "FOREIGN"
                ? 1200
                : Math.ceil(_bookCount / _booksPerBox) * 100
            )
          : 0;

      // 只折方案，不折書本
      const _discountedPlanOnly = calculateDiscountedPrice(_planSubtotal);
      const finalPrice = _discountedPlanOnly + _booksTotal + _shippingFee + _rpAddonTotal;
      const coupon = couponInfo;

      const addressType = (form_data.address_type || "TW").toUpperCase();

      // 台灣地址：deliver 是 array 就 join
      const deliverStr =
        addressType === "TW"
          ? (Array.isArray(form_data.deliver) ? form_data.deliver.join(",") : (form_data.deliver || ""))
          : ""; // FOREIGN 時清空

      // 國外地址：只在 FOREIGN 時送
      const foreignAddress =
        addressType === "FOREIGN"
          ? (form_data.foreign_address || "")
          : null;


      const mergeTepbOptions = (selected = [], otherValue = "") => {
        const arr = Array.isArray(selected)
          ? selected.filter((item) => item !== "其他")
          : [];

        if (Array.isArray(selected) && selected.includes("其他") && otherValue.trim()) {
          arr.push(otherValue.trim());
        }

        return arr.join("、");
      };

      const finalTepbReason = _isTEPB
        ? mergeTepbOptions(form_data.tepb_reasons, form_data.tepb_reason_other || "")
        : null;

      const finalTepbBackground = _isTEPB
        ? mergeTepbOptions(form_data.tepb_background, form_data.tepb_background_other || "")
        : null;

      const requestData = {
        mem_id: mem_data.mem_id,
        product_id: planData.product_id,
        total_price: finalPrice,
        pay_method: paymentMethod === "CreditCard" ? "CREDITCARD" : "ATM",
        pay_status: paymentMethod === "CreditCard" ? "PENDING" : "CONFIRMING",
        discount_id: coupon?.type === "discount" ? coupon.data.discount_id : null,
        mou_id: coupon?.type === "mou" ? coupon.data.mou_id : null,
        partner_id: null,

        tax_num: form_data.tax_num || null,
        company: form_data.company || null,

        // CPE
        cpe_email: form_data.cpe_email || null,
        cpe_activation_date: form_data.cpe_activation_date || null,
        cpe_company_name: form_data.cpe_company_name || null,

        // CSU
        bridge_birthdate: _isCSU ? form_data.bridge_birthdate || null : null,
        bridge_courses: _isCSU ? form_data.bridge_courses || [] : null,

        // UT
        ut_activation_date: _isUT ? form_data.ut_activation_date || null : null,
        ut_reasons: _isUT
          ? (Array.isArray(form_data.ut_reasons)
              ? form_data.ut_reasons.join(",")
              : form_data.ut_reasons || "")
          : null,
        //EA
        ea_parts: Array.isArray(form_data.ea_parts) ? form_data.ea_parts.join(",") : null,
        
        //CIA
        cia_subjects: Array.isArray(form_data.cia_subjects)
          ? form_data.cia_subjects.join(",")
          : null,
          
        // ✅ 地址：二選一
        deliver: deliverStr,
        address_type: addressType,
        foreign_address: foreignAddress,

        software_ex: !isNaN(software_ex.getTime())
          ? software_ex.toISOString().split("T")[0]
          : null,

        extension: null,

        memo: null,

        order_date,
        transfer_date,
        transfer_name,

        // 書/課程
        book: Array.isArray(form_data.book) ? form_data.book.join(",") : "",
        course: form_data.course || "",

        // RP
        rp_addons: _isRP ? _rpAddons.join(",") : null,
        rp_chinese_option: _isRP ? (form_data.chinese_class_option || null) : null,
        rp_chinese_subjects: _isRP
          ? (Array.isArray(form_data.chinese_inperson_subjects)
              ? form_data.chinese_inperson_subjects.join(",")
              : (form_data.chinese_inperson_subjects || null))
          : null,

        tepb_reason: finalTepbReason,
        tepb_background: finalTepbBackground,
      };

      const resp = await axios.post(`${backend}order/create-order`, requestData, {
        headers: {
          "Content-Type": "application/json",
          "Idempotency-Key": idemKey,
        },
      });

      const orderId = resp?.data?.orderId ?? null;
      // ===== 信用卡付款 =====
      if (paymentMethod === "CreditCard") {

        if (!orderId) {
          throw new Error("缺少 orderId");
        }

        const ccRes = await axios.post(
          `${backend}pay/hncb/create`,
          {
            order_id: orderId,
            mem_id: mem_data.mem_id,
            product_id: planData.product_id,
            total_price: finalPrice,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
            withCredentials: true,
          }
        );

        // 華南 auto-submit html
        const html = ccRes?.data?.html;

        if (!html) {
          throw new Error("未取得信用卡表單");
        }

        // 導向華南
        document.open();
        document.write(html);
        document.close();

        return;
      }
      // ✅ 是否要顯示「前往領書」選項（有買書且不是快遞且 TW）
      const askPickup = shouldAskBookPickup(form_data, planData);

      const result = await Swal.fire({
        icon: "success",
        title: "購買成功",
        html: askPickup
          ? `
            <div style="line-height:1.7">
              感謝您購買成功！我們將於一個工作天內為您開立帳號並聯繫您。<br/>
              <br/>
              <b>您已選擇紙本書籍</b>，且未選擇快遞寄送，是否要現在申請領書時間與方式？
            </div>
          `
          : `
            <div style="line-height:1.7">
              感謝您購買成功！我們將於一個工作天內為您開立帳號並聯繫您。
            </div>
          `,
        showCancelButton: askPickup,
        confirmButtonText: askPickup ? "前往領書申請" : "確定",
        cancelButtonText: "稍後再說",
        confirmButtonColor: "#224040",
        allowOutsideClick: false,
      });

      if (result.isConfirmed && askPickup) {
        if (orderId) localStorage.setItem("lastOrderId", String(orderId));
        navigated = true;
        navigate("/member/book");
        return;
      }

      navigated = true;
      window.location.href = "/";
      return;

    } catch (error) {
      console.error("Error creating order:", error?.response?.data || error?.message);
      Swal.fire({
        title: "購買失敗",
        text: "無法完成您的購買，請稍後再試。",
        icon: "error",
        confirmButtonText: "確定",
      });
    } finally {
      if (!navigated) setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="container mb100 mt100">
        <div className="beckertitlename mt100 mb-5">付款資訊</div>

        <div className={`card w-75 p-5 m-auto ${isSubmitting ? "pe-none opacity-50" : ""}`}>
          <div className="form-group mb-4">
            <div>
              {planData ? (
                <div className="plan-details mb-5">
                  <div className="mt-3">
                    <h4>購買方案</h4>
                    <div dangerouslySetInnerHTML={{ __html: planData.name }}></div>

                  </div>

                  <div className="mt-3">
                    <h4>方案內容</h4>
                    <div
                      className="card-body"
                      dangerouslySetInnerHTML={{ __html: planData.content }}
                    ></div>
                  </div>

                  <div className="mt-3">
                    <h4>方案價格</h4>
                    <div className="fs-5">$ {planSubtotal.toLocaleString()} 元</div>
                    {isCIASingle && (
                      <small className="text-muted d-block">
                        單科 ${unitPrice.toLocaleString()} × {ciaCount} 科
                      </small>
                    )}
                    {isCSU && (
                      <small className="text-muted d-block">
                        單門 ${unitPrice.toLocaleString()} × {csuCount} 門
                      </small>
                    )}
                  </div>

                  {isRP && rpAddonTotal > 0 && (
                    <div className="mt-2">
                      <h5 className="mb-1">舊生續購加購</h5>
                      <div className="fs-6">
                        <strong>= $ {rpAddonTotal.toLocaleString()} 元</strong>
                      </div>
                      <small className="text-muted d-block">
                        {rpAddons.join(", ")}
                      </small>
                    </div>
                  )}

                  {bookCount > 0 && booksTotal > 0 && (
                    <div className="mt-2">
                      <h5 className="mb-1">加購書本</h5>
                      <div className="fs-6">
                        {bookCount} 本
                        <strong className="ms-2">
                          = $ {booksTotal.toLocaleString()} 元
                        </strong>
                      </div>
                    </div>
                  )}
                  
                  {bookCount > 0 && shippingFee > 0 && (
                    <div className="mt-2">
                      <h5 className="mb-1">運費</h5>
                      <div className="fs-6">
                        {addressType === "FOREIGN"
                          ? "國際運費"
                          : `${Math.ceil(bookCount / booksPerBox)} 箱 × $100`}
                        <strong className="ms-2">
                          = $ {shippingFee.toLocaleString()} 元
                        </strong>
                      </div>
                    </div>
                  )}

                  <div className="mt-2">
                    <h5 className="mb-1">小計</h5>
                    <div className="fs-6">
                      <strong>$ {baseSubtotal.toLocaleString()} 元</strong>
                    </div>
                  </div>

                  <div className="mt-3">
                    <h4>折扣後金額</h4>
                    <strong>$ {discountedTotal.toLocaleString()} 元</strong>
                  </div>

                  <div className="mt-4">
                    <label>優惠碼</label>
                    <div className="d-flex gap-2">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="請輸入優惠碼"
                        value={coupon}
                        onChange={(e) => setCoupon(e.target.value)}
                        style={{ maxWidth: "200px" }}
                        disabled={isSubmitting}
                      />
                      <button
                        className="btn btn-outline-primary"
                        onClick={checkCoupon}
                        disabled={isSubmitting}
                        type="button"
                      >
                        輸入
                      </button>
                    </div>
                    {couponInfo && (
                      <div className="text-success mt-2">
                        成功套用優惠碼：{couponInfo.data.code}，折抵 NT$
                        {couponInfo.data.discount}
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <p>加载中...</p>
              )}
            </div>

            <label className="mb-5">付款方式</label>
            <div className="middle">
              <label>
                <input
                  type="radio"
                  name="radio"
                  checked={paymentMethod === "ATM"}
                  onChange={() => handlePaymentMethodChange("ATM")}
                  disabled={isSubmitting}
                />
                <div className="front-end box">
                  <span>ATM轉帳</span>
                </div>
              </label>

              
              {/* <label>
                <input
                  type="radio"
                  name="radio"
                  checked={paymentMethod === "CreditCard"}
                  onChange={() => handlePaymentMethodChange("CreditCard")}
                  disabled={isSubmitting}
                />
                <div className="back-end box">
                  <span>信用卡付款</span>
                </div>
              </label> */}
             

              {ccEnabled && (
                <label>
                  <input
                    type="radio"
                    name="radio"
                    checked={paymentMethod === "CreditCard"}
                    onChange={() => handlePaymentMethodChange("CreditCard")}
                    disabled={isSubmitting}
                  />
                  <div className="back-end box">
                    <span>信用卡付款</span>
                    {/* {ccQuota && (
                      <small style={{ display: "block" }}>
                        本月剩餘名額：{ccQuota.remaining}/{ccQuota.limit}
                      </small>
                    )} */}
                  </div>
                </label>
              )}
            </div>
          </div>

          {paymentMethod === "ATM" && (
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="atm">
                <div className="card-body">
                  付費購買匯款資訊
                  <br />
                  【在台購買】
                  <br />
                  收款人戶名：捷進顧問有限公司
                  <br />
                  受款銀行：華南商業銀行信維分行 (代碼：008 )
                  <br />
                  收款人帳號：149-10-010062-0
                  <br />
                  <br />
                  匯款金額：以新台幣付費，依各方案價格 (若需快遞書籍，請加上運費)
                  <br />
                  快遞計費方式：
                  EA 紙本書籍單箱最多可裝 3 本，
                  CPA / CMA 紙本書籍單箱最多可裝 2 本，
                  每箱快遞費 TWD 100 元。
                  <br />
                  __________________
                  <br />
                  <br />
                  【海外購買】
                  <br />
                  Recipient Name: Direct Line Consulting Co.
                  <br />
                  Account Number: 149-10-010062-0
                  <br />
                  <br />
                  Bank: Hua Nan Commercial Bank Ltd.
                  <br />
                  Branch: Hsin-Wei Branch
                  <br />
                  SWIFT Code (Bank ID): <br />
                  <br />
                  HNBKTWTP149
                  <br />
                  Bank Address: 2F, No.6, Xinyi Rd. Sec. 4, Da'an Dist., 106
                  Taipei City, Taiwan
                  <br />
                  <br />
                  匯款金額：以新台幣付費，依各方案價格 (全額到匯)
                </div>

                <div className="form-group mb-4">
                  <label className="mb-2">匯款 / 轉帳日期</label>
                  <input
                    type="date"
                    className={`form-control ${errors.transfer_date ? "is-invalid" : ""}`}
                    id="payment"
                    disabled={isSubmitting}
                  />
                  <small className="form-text text-muted">
                    Becker Taiwan 將依此核對確認您的款項
                  </small>
                  {errors.transfer_date && (
                    <div className="invalid-feedback">{errors.transfer_date}</div>
                  )}
                </div>

                <div className="form-group mb-4">
                  <label className="mb-2">匯款 (存款) 人姓名、或轉出帳戶後五碼</label>
                  <input
                    type="text"
                    className={`form-control ${errors.transfer_name ? "is-invalid" : ""}`}
                    id="payer"
                    disabled={isSubmitting}
                  />
                  {errors.transfer_name && (
                    <div className="invalid-feedback">{errors.transfer_name}</div>
                  )}
                </div>

                <button
                  className="btn btn-primary"
                  onClick={handleSubmit}
                  type="button"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "送出中…" : "送出"}
                </button>
              </div>
            </form>
          )}

          {paymentMethod === "CreditCard" && (
            <div className="mt-4">
              <div className="alert alert-info">
                點擊下方按鈕後，將前往華南銀行安全刷卡頁面完成付款。
                本站不會收集卡號、有效期限或安全碼。
              </div>

              <button
                className="btn btn-primary"
                onClick={handleSubmit}
                type="button"
                disabled={isSubmitting}
              >
                {isSubmitting ? "導向刷卡頁中…" : "前往華南銀行刷卡"}
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Pay;